module.exports = __webpack_public_path__ + "static/media/applause.c2030d5b.mp3";